module.exports = __webpack_public_path__ + "img/1F973.b477e0fb.svg";